import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const SagUpp = lazy(() => import("@/pages/elavtal/SagUpp"));

export const Route = createFileRoute("/elavtal/sag-upp")({
  head: () => seoHead("/elavtal/sag-upp", { description: "Att säga upp ditt elavtal är enkelt och kostar inget om du inte har bindningstid. Här är allt du behöver veta." }),
  component: () => <SagUpp />,
});
